import { StoreUI, useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';

export const useReactToScrollButtons = (
    scrollRef: HTMLDivElement,
    uiStore: StoreUI,
    scrollSpeed = 100
) => {
    const scrollInterval = useRef(null);
    useEffect(() => {
        const clearTimer = () => {
            if (scrollInterval.current) {
                clearInterval(scrollInterval.current);
                scrollInterval.current = null;
            }
        };

        clearTimer();

        if (scrollRef) {
            if (uiStore.scrolling == 'UP') {
                scrollInterval.current = setInterval(() => {
                    if (scrollRef) {
                        scrollRef.scrollBy(0, -scrollSpeed);
                    }
                }, 50);
            } else if (uiStore.scrolling == 'DOWN') {
                scrollInterval.current = setInterval(() => {
                    if (scrollRef) {
                        scrollRef.scrollBy(0, scrollSpeed);
                    }
                }, 50);
            }

            return () => {
                clearTimer();
            };
        }
    }, [scrollRef, uiStore.scrolling]);
};
